import React, { useEffect, useRef, useState } from 'react'
import { Skeleton } from 'primereact/skeleton'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import UsuarioServiceAPI from '../../service/UsuarioServiceAPI'
import moment from 'moment'
import { formataCelular } from '../../components/utils/FormatacaoString'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function UsuariosPendentes() {
  const [loading, setLoading] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [modalEditarUsuario, setModalEditarUsuario] = useState(false)
  const [editarUsuarioId, setEditarUsuarioId] = useState(null)

  const [nomeUsuarioEditar, setNomeUsuarioEditar] = useState('')
  const [emailUsuarioEditar, setEmailUsuarioEditar] = useState('')
  const [documentoUsuarioEditar, setDocumentoUsuarioEditar] = useState('')
  const [telefoneUsuarioEditar, setTelefoneUsuarioEditar] = useState('')
  const [cotaUsuarioEditar, setCotaUsuarioEditar] = useState('')
  const [grupoUsuarioEditar, setGrupoUsuarioEditar] = useState('')
  const [propostaUsuarioEditar, setPropostaUsuarioEditar] = useState('')

  const userService = new UsuarioServiceAPI()

  const toast = useRef()
  const history = useHistory()

  const handleEditarUsuario = (user) => {
    setEditarUsuarioId(user?.id)
    setModalEditarUsuario(true)
    setNomeUsuarioEditar(user?.nome)
    setEmailUsuarioEditar(user?.email)
    setDocumentoUsuarioEditar(user?.cpfCnpj)
    setTelefoneUsuarioEditar(user?.telefone)
    setCotaUsuarioEditar(user?.cota)
    setGrupoUsuarioEditar(user?.grupo)
    setPropostaUsuarioEditar(user?.proposta)
  }

  const formatarUsuarios = (data) => {
    let usersFormatado = []
    data?.forEach((user) => {
      let obj = {
        ...user,
        telefone: formataCelular(user?.telefone),
        acoes: (
          <div className=''>
            <Button
              className='p-button'
              icon='pi pi-pencil'
              label='Editar usuário'
              onClick={() => handleEditarUsuario(user)}
            />
          </div>
        ),
      }

      usersFormatado.push(obj)
    })

    return usersFormatado
  }

  const hideModalEditarUsuario = () => {
    setModalEditarUsuario(false)
    setEditarUsuarioId(null)
  }

  const footerModalEditarUsuario = () => {
    return (
      <div className='flex justify-content-end' style={{ gap: 8 }}>
        <Button
          icon='pi pi-times'
          label='Cancelar'
          className='p-button p-button-danger'
          type='button'
          onClick={hideModalEditarUsuario}
        />
        <Button
          icon='pi pi-save'
          label='Salvar'
          className='p-button p-button-success'
          type='submit'
          form='edit-user'
        />
      </div>
    )
  }

  const getUsers = async () => {
    userService.getUsuariosPendentes().then(({ data }) => {
      setUsuarios(formatarUsuarios(data))
      setLoading(false)
    })
  }

  const handleUpdateUser = (e) => {
    e.preventDefault()

    let updateUser = {
      id: editarUsuarioId,
      nome: nomeUsuarioEditar,
      email: emailUsuarioEditar,
      cpfCnpj: documentoUsuarioEditar,
      telefone: telefoneUsuarioEditar,
      cota: cotaUsuarioEditar,
      grupo: grupoUsuarioEditar,
      proposta: propostaUsuarioEditar,
    }
    setLoading(true)
    userService
      .updateUserPendentes(updateUser)
      .then(() => {
        toast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Usuário atualizado com sucesso!',
          life: 3000,
        })
        getUsers()
        setModalEditarUsuario(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    setLoading(true)
    getUsers()
  }, [])

  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        header='Editar usuário'
        onHide={hideModalEditarUsuario}
        visible={modalEditarUsuario}
        footer={footerModalEditarUsuario}
        style={{ width: 'full', maxWidth: 780 }}
      >
        <form
          action=''
          id='edit-user'
          className='grid mt-4'
          onSubmit={handleUpdateUser}
        >
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setNomeUsuarioEditar(e?.target.value)}
                value={nomeUsuarioEditar}
                name='nome'
                className='w-full'
                required
              />
              <label>Nome</label>
            </span>
          </div>
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setEmailUsuarioEditar(e?.target.value)}
                value={emailUsuarioEditar}
                name='email'
                className='w-full'
                required
              />
              <label>Email</label>
            </span>
          </div>
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setDocumentoUsuarioEditar(e?.target.value)}
                value={documentoUsuarioEditar}
                name='cpfCnpj'
                className='w-full'
                required
              />
              <label>Documento</label>
            </span>
          </div>
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setTelefoneUsuarioEditar(e?.target.value)}
                value={telefoneUsuarioEditar}
                name='telefone'
                className='w-full'
                required
              />
              <label>Telefone</label>
            </span>
          </div>
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setCotaUsuarioEditar(e?.target.value)}
                value={cotaUsuarioEditar}
                name='cota'
                className='w-full'
                required
              />
              <label>Cota</label>
            </span>
          </div>
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setGrupoUsuarioEditar(e?.target.value)}
                value={grupoUsuarioEditar}
                name='grupo'
                className='w-full'
                required
              />
              <label>Grupo</label>
            </span>
          </div>
          <div className='col-12 md:col-6 mb-3'>
            <span className='p-input-icon-right p-float-label w-full'>
              <InputText
                onChange={(e) => setPropostaUsuarioEditar(e?.target.value)}
                value={propostaUsuarioEditar}
                name='proposta'
                className='w-full'
                required
              />
              <label>Proposta</label>
            </span>
          </div>
        </form>
      </Dialog>

      <h5 className='mb-4'>Lista de cadastros pendentes</h5>

      <div className='grid'>
        <div className='card col-12'>
          {loading ? (
            <Skeleton height={300} />
          ) : (
            <DataTable
              paginator
              rows={15}
              value={usuarios}
              responsiveLayout='scroll'
              emptyMessage='Nenhuma marca encontrada'
              dataKey='id'
            >
              <Column
                filter
                className='white-space-nowrap'
                field='nome'
                header='Nome'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='email'
                header='E-mail'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='cpfCnpj'
                header='Documento'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='telefone'
                header='Telefone'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='cota'
                header='Cota'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='grupo'
                header='Grupo'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='proposta'
                header='Proposta'
                style={{ width: 'auto' }}
              />
              <Column
                className='white-space-nowrap'
                field='acoes'
                header='Ações'
                style={{ width: 'auto' }}
              />
            </DataTable>
          )}
        </div>
      </div>
    </div>
  )
}
